// extracted by mini-css-extract-plugin
module.exports = {"BannerText":"Home__BannerText__15hN7"};